import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOnTargetVariant2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M7.5 6C7.5 6.82843 6.82843 7.5 6 7.5C5.17157 7.5 4.5 6.82843 4.5 6C4.5 5.17157 5.17157 4.5 6 4.5C6.82843 4.5 7.5 5.17157 7.5 6Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6 0.5C6.27614 0.5 6.5 0.723858 6.5 1V1.52746C8.58581 1.75804 10.242 3.41419 10.4725 5.5H11C11.2761 5.5 11.5 5.72386 11.5 6C11.5 6.27614 11.2761 6.5 11 6.5H10.4725C10.242 8.58581 8.58581 10.242 6.5 10.4725V11C6.5 11.2761 6.27614 11.5 6 11.5C5.72386 11.5 5.5 11.2761 5.5 11V10.4725C3.41419 10.242 1.75804 8.58581 1.52746 6.5H1C0.723858 6.5 0.5 6.27614 0.5 6C0.5 5.72386 0.723858 5.5 1 5.5H1.52746C1.75804 3.41419 3.41419 1.75804 5.5 1.52746V1C5.5 0.723858 5.72386 0.5 6 0.5ZM6.5 9.46456V9C6.5 8.72386 6.27614 8.5 6 8.5C5.72386 8.5 5.5 8.72386 5.5 9V9.46456C3.96715 9.2453 2.7547 8.03285 2.53544 6.5H3C3.27614 6.5 3.5 6.27614 3.5 6C3.5 5.72386 3.27614 5.5 3 5.5H2.53544C2.7547 3.96715 3.96715 2.7547 5.5 2.53544V3C5.5 3.27614 5.72386 3.5 6 3.5C6.27614 3.5 6.5 3.27614 6.5 3V2.53544C8.03285 2.7547 9.2453 3.96715 9.46456 5.5H9C8.72386 5.5 8.5 5.72386 8.5 6C8.5 6.27614 8.72386 6.5 9 6.5H9.46456C9.2453 8.03285 8.03285 9.2453 6.5 9.46456Z",
		fill: "currentColor"
	})]
});
export default SvgOnTargetVariant2;
